import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import InstructionRepeatOverlay from './InstructionRepeatOverlay';
import { MAX_REPLAYS } from './modularMultipleChoiceConstants';

export default function MmcMediaSection({
  hasVideo,
  hasImage,
  hideMedia,
  videoURL,
  imageURL,
  speech,
  videoPlaying,
  submitted,
  unmountVideoWhenDone,
  suppressVideoReplayOverlay,
  showRepeatOverlay,
  pointerTarget,
  onRepeatOverlayReplay,
  onRepeatOverlayNext,
  onVideoStart,
  onVideoDone,
}) {
  if (!((hasVideo && !hideMedia) || (hasImage && !hasVideo && !hideMedia))) {
    return null;
  }

  return (
    <div className="modularMultipleChoice__media">
      {hasVideo && !hideMedia && (
        <div className="modularMultipleChoice__mediaSlot">
          <VideoPlayer
            videoURL={videoURL}
            text="Multiple Choice Video"
            unmountWhenDone={unmountVideoWhenDone}
            key="modularMultipleChoiceVideo"
            speech={speech}
            videoPlaying={videoPlaying}
            maxReplays={submitted ? 0 : MAX_REPLAYS}
            suppressReplayOverlay={suppressVideoReplayOverlay}
            onStart={onVideoStart}
            onDone={onVideoDone}
            useButtonLabels={false}
            useClearButtons={true}
          />
          {showRepeatOverlay && (
            <InstructionRepeatOverlay
              pointerTarget={pointerTarget}
              onReplay={onRepeatOverlayReplay}
              onNext={onRepeatOverlayNext}
            />
          )}
        </div>
      )}
      {hasImage && !hasVideo && !hideMedia && (
        <div className="modularMultipleChoice__staticImage">
          <div className="modularMultipleChoice__staticImageCell">
            <img src={imageURL} alt="Multiple choice prompt" />
            {showRepeatOverlay && (
              <InstructionRepeatOverlay
                pointerTarget={pointerTarget}
                onReplay={onRepeatOverlayReplay}
                onNext={onRepeatOverlayNext}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
